import { __decorate } from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
let PiHomeDataTimeType = class PiHomeDataTimeType extends Vue {
    tabClick(active) {
        this.$emit("change", active);
    }
};
__decorate([
    Prop({ default: "1" })
], PiHomeDataTimeType.prototype, "active", void 0);
PiHomeDataTimeType = __decorate([
    Component
], PiHomeDataTimeType);
export default PiHomeDataTimeType;
